(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-day-night"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-dn]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const box = root.querySelector('[data-cmp]');
    const range = box.querySelector('input[type=range]');
    const day = box.querySelector('[data-day]');
    const night = box.querySelector('[data-night]');
    const tabs = [...root.querySelectorAll('[data-scene]')];
    range.addEventListener('input', () => box.style.setProperty('--pos', range.value + '%'));
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const scene = tab.dataset.scene;
      tabs.forEach((t) => t.setAttribute('aria-pressed', String(t === tab)));
      day.src = day.dataset[scene];
      night.src = night.dataset[scene];
      box.style.setProperty('--pos', '50%');
      range.value = '50';
    }));
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-collection-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-ch]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const go = root.querySelector('[data-ac-ch-go]');
    if (go) go.addEventListener('click', (event) => {
      const target = document.getElementById('ProductGridContainer') || root.closest('.shopify-section').nextElementSibling;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    const video = root.querySelector('video');
    const conn = navigator.connection; const saver = conn && (conn.saveData || /2g|3g/.test(conn.effectiveType || ''));
    if (!video || saver || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const start = () => { const p = video.play(); if (p && p.catch) p.catch(() => {}); };
    if (document.readyState === 'complete') setTimeout(start, 400); else window.addEventListener('load', () => setTimeout(start, 400), { once: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { if (video.paused && video.readyState > 0) start(); } else if (!video.paused) video.pause(); }), { threshold: 0.1 }).observe(video);
    }
  });
  const run = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-holiday-giveaway"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = scope => {
    scope.querySelectorAll('[data-holiday-draw]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const entry = root.querySelector('[data-draw-entry]');
      if (entry && root.querySelector('[data-draw-success], .ac-gift__signup-error')) entry.open = true;
      const deadline = Date.parse(root.dataset.deadline);
      const tick = () => {
        if (!root.isConnected) { clearInterval(timer); return; }
        if (!Number.isFinite(deadline)) return;
        const left = Math.max(0, deadline - Date.now());
        if (!left) { root.querySelector('.ac-gift__clock').textContent = root.dataset.closedLabel; const form = root.querySelector('form'); if (form) { form.querySelectorAll('input,button').forEach(field => { field.disabled = true; }); } return; }
        root.querySelector('[data-draw-days]').textContent = String(Math.floor(left / 86400000)).padStart(2, '0');
        root.querySelector('[data-draw-hours]').textContent = String(Math.floor(left / 3600000) % 24).padStart(2, '0');
        root.querySelector('[data-draw-minutes]').textContent = String(Math.floor(left / 60000) % 60).padStart(2, '0');
      };
      let timer;
      tick(); timer = setInterval(tick, 60000);
      root.querySelectorAll('[data-giveaway-rules-link]').forEach(link => link.addEventListener('click', event => {
        const rules = document.getElementById(link.getAttribute('href').slice(1));
        if (!rules) return;
        event.preventDefault();
        root.querySelector('[data-draw-entry]').open = true;
        rules.open = true;
        rules.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));
    });
    scope.querySelectorAll('[data-holiday-notice]').forEach(note => {
      if (note.dataset.ready) return;
      note.dataset.ready = 'true';
      const key = note.classList.contains('hbc-note') ? 'aligncart-holiday-2026-holly-v3' : 'aligncart-holiday-2026-notice-v2';
      const read = name => { try { return sessionStorage.getItem(name); } catch { return null; } };
      const write = (name, value) => { try { sessionStorage.setItem(name, value); } catch {} };
      const dismiss = () => { note.hidden = true; write(key, 'seen'); };
      const overlapsPurchase = () => {
        const purchaseInfo = document.querySelector('.hbc-page') && document.querySelector('.product__info-container, .we-offer');
        if (purchaseInfo) {
          const p = purchaseInfo.getBoundingClientRect();
          if (p.top < window.innerHeight && p.bottom > 0) return true;
        }
        const r = note.getBoundingClientRect();
        return [...document.querySelectorAll('button[name="add"], .gv-add, .pn-add, .we-add, .pc-add, .main-product-atc, .shopify-payment-button__button')].some(button => {
          const b = button.getBoundingClientRect();
          return b.width && b.height && b.top < r.bottom && b.bottom > r.top && b.left < r.right && b.right > r.left;
        });
      };
      const protectPurchase = () => { if (!note.hidden && overlapsPurchase()) dismiss(); };
      window.addEventListener('scroll', protectPurchase, { passive: true });
      window.addEventListener('resize', protectPurchase, { passive: true });
      window.visualViewport?.addEventListener('resize', protectPurchase, { passive: true });
      document.addEventListener('submit', () => { if (!note.hidden) dismiss(); }, true);
      document.addEventListener('click', event => { if (!note.hidden && event.target.closest('#cart-icon-bubble')) dismiss(); });
      note.querySelector('[data-notice-close]').addEventListener('click', dismiss);
      note.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
      note.querySelector('[data-notice-offer]').addEventListener('click', event => {
        const card = document.querySelector('[data-holiday-draw]');
        dismiss();
        if (!card) return;
        event.preventDefault();
        const expanded = card.querySelector('.hbc-giveaway-details');
        if (expanded) expanded.open = true;
        card.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        card.focus({ preventScroll: true });
      });
      if (read(key) === 'seen' || location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')) return;
      const deadline = Date.parse(note.dataset.deadline);
      const started = Number(read(key + '-start')) || Date.now();
      write(key + '-start', String(started));
      const show = () => {
        if (!note.isConnected || read(key) === 'seen' || (Number.isFinite(deadline) && Date.now() >= deadline)) return;
        const focused = document.activeElement;
        const busy = document.hidden || document.querySelector('dialog[open], cart-drawer.active, cart-notification.active, details-modal details[open]') || focused?.matches('input,textarea,select,[contenteditable="true"]');
        if (busy) { setTimeout(show, 2500); return; }
        const header = document.querySelector('.shopify-section-header, .header-wrapper, header.header');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        note.style.setProperty('--ac-notice-top', Math.max(14, Math.min(headerBottom + 12, 140)) + 'px');
        note.hidden = false;
        if (overlapsPurchase()) { note.hidden = true; setTimeout(show, 2500); return; }
        write(key, 'seen');
        note.dataset.shownAt = String(Date.now());
      };
      setTimeout(show, Math.max(0, 15000 - (Date.now() - started)));
    });
  };
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-home-block"] && !Shopify.designMode) return;
  try {
    
(() => {
  const run = (scope) => scope.querySelectorAll('[data-ac-hbv]').forEach((v) => {
    if (v.dataset.ready) return;
    v.dataset.ready = '1';
    const c = navigator.connection;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || (c && (c.saveData || /2g|3g/.test(c.effectiveType || ''))) || !('IntersectionObserver' in window)) return;
    new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { const p = v.play(); if (p && p.then) p.then(() => v.classList.add('is-on')).catch(() => {}); } else { v.pause(); }
    }), { threshold: 0.35 }).observe(v);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document)); else run(document);
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-home-pick"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-pick]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const chips = [...root.querySelectorAll('.ac-pick__chip')];
    const cards = [...root.querySelectorAll('.ac-pick__card')];
    const empty = root.querySelector('.ac-pick__empty');
    const apply = (filter) => {
      let shown = 0;
      cards.forEach((card) => {
        const ok = filter === 'all' || (card.dataset.tags || '').split(/\s+/).indexOf(filter) > -1;
        card.hidden = !ok;
        if (ok) shown += 1;
      });
      chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.filter === filter)));
      empty.hidden = shown > 0;
      empty.textContent = shown > 0 ? '' : 'Nothing here yet. Try another category.';
    };
    chips.forEach((chip) => chip.addEventListener('click', () => apply(chip.dataset.filter)));
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-projector-demo"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const setup = (scope) => scope.querySelectorAll('[data-ac-demo]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const shot = root.querySelector('[data-shot]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.setAttribute('aria-pressed', String(t === thumb)));
      if (shot) { shot.src = thumb.dataset.src; shot.alt = thumb.dataset.alt; }
    }));
    const compare = root.querySelector('[data-compare]');
    if (!compare) return;
    const range = root.querySelector('[data-range]');
    const before = root.querySelector('[data-before]');
    const after = root.querySelector('[data-after]');
    const name = root.querySelector('[data-name]');
    const houses = [...root.querySelectorAll('[data-house]')];
    const set = (value) => { compare.style.setProperty('--pos', value + '%'); range.value = String(value); };
    let touched = false;
    range.addEventListener('input', () => { touched = true; set(Number(range.value)); });
    houses.forEach((house) => house.addEventListener('click', () => {
      houses.forEach((h) => h.setAttribute('aria-pressed', String(h === house)));
      before.src = house.dataset.before; after.src = house.dataset.after;
      before.alt = house.dataset.name + ' house at night without a projector (concept image)';
      after.alt = house.dataset.name + ' house with a projected holiday display (concept image)';
      name.textContent = house.dataset.name;
      set(50);
    }));
    if (!reduce && 'IntersectionObserver' in window) {
      const watcher = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        watcher.disconnect();
        const start = performance.now();
        const frame = (now) => {
          if (touched) return;
          const t = Math.min((now - start) / 2200, 1);
          set(Math.round(50 + 28 * Math.sin(t * Math.PI * 2)));
          if (t < 1) requestAnimationFrame(frame); else set(50);
        };
        requestAnimationFrame(frame);
      }, { threshold: 0.6 });
      watcher.observe(compare);
    }
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-strange-compare"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const setup = (scope) => scope.querySelectorAll('[data-ac-room]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const shot = root.querySelector('[data-shot]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.setAttribute('aria-pressed', String(t === thumb)));
      if (shot) { shot.src = thumb.dataset.src; shot.alt = thumb.dataset.alt; }
    }));
    const compare = root.querySelector('[data-compare]');
    if (!compare) return;
    const range = root.querySelector('[data-range]');
    const before = root.querySelector('[data-before]');
    const after = root.querySelector('[data-after]');
    const name = root.querySelector('[data-name]');
    const rooms = [...root.querySelectorAll('[data-room]')];
    const set = (value) => { compare.style.setProperty('--pos', value + '%'); range.value = String(value); };
    let touched = false;
    range.addEventListener('input', () => { touched = true; set(Number(range.value)); });
    rooms.forEach((room) => room.addEventListener('click', () => {
      rooms.forEach((r) => r.setAttribute('aria-pressed', String(r === room)));
      before.src = room.dataset.before; after.src = room.dataset.after;
      before.alt = room.dataset.name + ' room without a projector (concept image)';
      after.alt = room.dataset.name + ' room with the projected scene (concept image)';
      name.textContent = room.dataset.name;
      set(50);
    }));
    if (!reduce && 'IntersectionObserver' in window) {
      const watcher = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        watcher.disconnect();
        const start = performance.now();
        const frame = (now) => {
          if (touched) return;
          const t = Math.min((now - start) / 2200, 1);
          set(Math.round(50 + 28 * Math.sin(t * Math.PI * 2)));
          if (t < 1) requestAnimationFrame(frame); else set(50);
        };
        requestAnimationFrame(frame);
      }, { threshold: 0.6 });
      watcher.observe(compare);
    }
  });
  const start = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligncart-strange-footage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-footage]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const frames = [...root.querySelectorAll('.ac-sf__frame')];
    const clips = [...root.querySelectorAll('.ac-sf__clip')];
    const tabs = [...root.querySelectorAll('.ac-sf__tab')];
    const pauseAll = (keep) => frames.forEach((f) => { const v = f.querySelector('video'); if (v && f !== keep) { v.pause(); f.classList.remove('is-playing'); } });
    const play = (frame) => { const video = frame.querySelector('video'); if (!video) return; pauseAll(frame); const p = video.play(); if (p && p.catch) p.catch(() => {}); frame.classList.add('is-playing'); };
    frames.forEach((frame) => {
      const video = frame.querySelector('video');
      const button = frame.querySelector('.ac-sf__play');
      if (!video) { button.hidden = true; return; }
      const toggle = () => {
        if (video.paused) play(frame);
        else { video.pause(); frame.classList.remove('is-playing'); }
      };
      button.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
    });
    const loadPoster = (frame) => { const v = frame.querySelector('video'); if (v && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); };
    if ('IntersectionObserver' in window) {
      const lazy = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { loadPoster(entry.target); lazy.unobserve(entry.target); } }), { rootMargin: '400px 0px' });
      frames.forEach((f) => lazy.observe(f));
    } else { frames.forEach(loadPoster); }
    const activate = (index, autoplay) => {
      clips.forEach((clip) => clip.classList.toggle('is-active', clip.dataset.clip === String(index)));
      tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab.dataset.tab === String(index))));
      pauseAll(null);
      if (autoplay) { const clip = clips.find((c) => c.dataset.clip === String(index)); if (clip) play(clip.querySelector('.ac-sf__frame')); }
    };
    const first = tabs.find((t) => t.dataset.first === 'true') || tabs[0];
    if (first && tabs.length) {
      first.parentNode.insertBefore(first, first.parentNode.firstChild);
      activate(first.dataset.tab, false);
    } else if (clips[0]) { clips[0].classList.add('is-active'); }
    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.tab, true)));
    if ('IntersectionObserver' in window) {
      const watcher = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) return;
        const v = entry.target.querySelector('video');
        if (v && !v.paused) { v.pause(); entry.target.classList.remove('is-playing'); }
      }), { threshold: 0.2 });
      frames.forEach((f) => watcher.observe(f));
    }
    const only = root.querySelector('[data-footage-only]');
    if (only) {
      const note = root.querySelector('.ac-sf__only-note');
      only.addEventListener('click', async () => {
        if (only.disabled) return;
        const label = only.textContent;
        only.disabled = true;
        only.textContent = 'Adding...';
        note.textContent = '';
        try {
          const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(root.dataset.footageVariant), quantity: 1 }] }) });
          if (!response.ok) { const data = await response.json().catch(() => ({})); throw new Error(data.description || 'Could not add the footage. Please try again.'); }
          window.location.assign(base + 'cart');
        } catch (failure) {
          note.textContent = failure.message || 'Could not add the footage. Please try again.';
          only.disabled = false;
          only.textContent = label;
        }
      });
    }
  });
  const bundle = () => {
    const root = document.querySelector('[data-footage-variant]');
    if (!root || root.dataset.bundled) return;
    const footageId = Number(root.dataset.footageVariant);
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!footageId || !form) return;
    root.dataset.bundled = 'true';
    document.addEventListener('submit', async (event) => {
      const target = event.target;
      if (!target || !target.matches || !target.matches('form[action*="/cart/add"]') || target.dataset.acBundling) return;
      const data = new FormData(target);
      const id = Number(data.get('id'));
      if (!id || id === footageId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      target.dataset.acBundling = 'true';
      const quantity = Math.max(1, Number(data.get('quantity')) || 1);
      const button = target.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      try {
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: quantity }, { id: footageId, quantity: 1 }] }) });
        if (!response.ok) throw new Error('add failed');
        window.location.assign(base + 'cart');
      } catch (_) {
        delete target.dataset.acBundling;
        if (button) button.disabled = false;
        target.requestSubmit ? target.requestSubmit() : target.submit();
      }
    }, true);
  };
  const start = () => { setup(document); bundle(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gracelight-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-gl-back]').forEach(link=>link.addEventListener('click',event=>{const form=document.querySelector('#MainContent .product-form');if(form){event.preventDefault();form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harvestglow-story"] && !Shopify.designMode) return;
  try {
    
function initializeHarvestGlow(scope){scope.querySelectorAll('[data-hg-compare]').forEach(function(compare){if(compare.dataset.bound)return;compare.dataset.bound='true';var range=compare.querySelector('input[type="range"]');range.addEventListener('input',function(){compare.style.setProperty('--hg-position',range.value+'%');});});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initializeHarvestGlow(document);});}else{initializeHarvestGlow(document);}document.addEventListener('shopify:section:load',function(event){initializeHarvestGlow(event.target);});
function initializeHarvestGlowPurchase(){
  const root=document.querySelector('[data-hg-bundle]');
  if(!root||root.dataset.purchaseBound)return;
  root.dataset.purchaseBound='true';
  const base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  const packId=Number(root.dataset.footageVariant);
  const add=async(items)=>{const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.description||'Could not add the item. Please try again.');}window.location.assign(base+'cart');};
  document.addEventListener('submit',async(event)=>{
    const form=event.target;
    if(!form.matches||!form.matches('form[action*="/cart/add"]'))return;
    if(event.submitter&&event.submitter.hasAttribute('data-buy-now'))return;
    const data=new FormData(form),id=Number(data.get('id'));
    if(![67847544701165,67847544733933].includes(id))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(form.dataset.hgBusy)return;
    form.dataset.hgBusy='true';
    const button=form.querySelector('[name="add"]');if(button)button.disabled=true;
    try{await add([{id,quantity:Math.max(1,Number(data.get('quantity'))||1)},{id:packId,quantity:1}]);}
    catch(error){delete form.dataset.hgBusy;if(button)button.disabled=false;const box=form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');if(box){box.hidden=false;const text=box.querySelector('.product-form__error-message');if(text)text.textContent=error.message;}}
  },true);
  const only=root.querySelector('[data-hg-pack-only]');
  if(only)only.addEventListener('click',async()=>{if(only.disabled)return;only.disabled=true;const box=root.querySelector('[data-hg-pack-error]');if(box)box.textContent='';try{await add([{id:packId,quantity:1}]);}catch(error){only.disabled=false;if(box)box.textContent=error.message;}});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeHarvestGlowPurchase);else initializeHarvestGlowPurchase();
document.addEventListener('shopify:section:load',initializeHarvestGlowPurchase);

function initializeHarvestGlowCinema(scope){
  scope.querySelectorAll('[data-hg-cinema]').forEach(function(cinema){
    if(cinema.dataset.bound)return;
    const panels=Array.from(cinema.querySelectorAll('[data-hg-panel]'));
    const choices=Array.from(cinema.querySelectorAll('[data-hg-select]'));
    if(!panels.length||choices.length!==panels.length)return;
    cinema.dataset.bound='true';
    panels.forEach(function(panel){
      const video=panel.querySelector('video'),play=panel.querySelector('[data-hg-play]');
      if(!video||!play)return;
      play.hidden=false;
      play.addEventListener('click',function(){video.play().catch(function(){play.hidden=false;});});
      video.addEventListener('play',function(){play.hidden=true;});
      video.addEventListener('pause',function(){play.hidden=false;});
    });
    function select(id,play){
      panels.forEach(function(panel){const active=panel.dataset.hgPanel===id;panel.hidden=!active;const video=panel.querySelector('video');if(!active&&video)video.pause();if(active&&play&&video)video.play().catch(function(){});});
      choices.forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.hgSelect===id));});
    }
    choices.forEach(function(button){button.addEventListener('click',function(){select(button.dataset.hgSelect,true);});});
    cinema.classList.add('is-ready');
    cinema.querySelector('[data-hg-scenes]').hidden=false;
    select(panels[0].dataset.hgPanel,false);
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initializeHarvestGlowCinema(document);});}else{initializeHarvestGlowCinema(document);}
document.addEventListener('shopify:section:load',function(event){initializeHarvestGlowCinema(event.target);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hollybeam-footage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope) => scope.querySelectorAll('[data-ac-footage]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const frames = [...root.querySelectorAll('.ac-sf__frame')];
    const clips = [...root.querySelectorAll('.ac-sf__clip')];
    const tabs = [...root.querySelectorAll('.ac-sf__tab')];
    const pauseAll = (keep) => frames.forEach((f) => { const v = f.querySelector('video'); if (v && f !== keep) { v.pause(); f.classList.remove('is-playing'); } });
    const play = (frame) => { const video = frame.querySelector('video'); if (!video) return; pauseAll(frame); const p = video.play(); if (p && p.catch) p.catch(() => {}); frame.classList.add('is-playing'); };
    frames.forEach((frame) => {
      const video = frame.querySelector('video');
      const button = frame.querySelector('.ac-sf__play');
      if (!video) { button.hidden = true; return; }
      const toggle = () => {
        if (video.paused) play(frame);
        else { video.pause(); frame.classList.remove('is-playing'); }
      };
      button.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
    });
    const loadPoster = (frame) => { const v = frame.querySelector('video'); if (v && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); };
    if ('IntersectionObserver' in window) {
      const lazy = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { loadPoster(entry.target); lazy.unobserve(entry.target); } }), { rootMargin: '400px 0px' });
      frames.forEach((f) => lazy.observe(f));
    } else { frames.forEach(loadPoster); }
    const activate = (index, autoplay) => {
      clips.forEach((clip) => clip.classList.toggle('is-active', clip.dataset.clip === String(index)));
      tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab.dataset.tab === String(index))));
      pauseAll(null);
      if (autoplay) { const clip = clips.find((c) => c.dataset.clip === String(index)); if (clip) play(clip.querySelector('.ac-sf__frame')); }
    };
    const first = tabs.find((t) => t.dataset.first === 'true') || tabs[0];
    if (first && tabs.length) {
      first.parentNode.insertBefore(first, first.parentNode.firstChild);
      activate(first.dataset.tab, false);
    } else if (clips[0]) { clips[0].classList.add('is-active'); }
    tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.tab, true)));
    if ('IntersectionObserver' in window) {
      const watcher = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) return;
        const v = entry.target.querySelector('video');
        if (v && !v.paused) { v.pause(); entry.target.classList.remove('is-playing'); }
      }), { threshold: 0.2 });
      frames.forEach((f) => watcher.observe(f));
    }
    const only = root.querySelector('[data-footage-only]');
    if (only) {
      const note = root.querySelector('.ac-sf__only-note');
      only.addEventListener('click', async () => {
        if (only.disabled) return;
        const label = only.textContent;
        only.disabled = true;
        only.textContent = 'Adding...';
        note.textContent = '';
        try {
          const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(root.dataset.footageVariant), quantity: 1 }] }) });
          if (!response.ok) { const data = await response.json().catch(() => ({})); throw new Error(data.description || 'Could not add the footage. Please try again.'); }
          window.location.assign(base + 'cart');
        } catch (failure) {
          note.textContent = failure.message || 'Could not add the footage. Please try again.';
          only.disabled = false;
          only.textContent = label;
        }
      });
    }
  });
  const bundle = () => {
    const root = document.querySelector('[data-footage-variant]');
    if (!root || root.dataset.bundled) return;
    const footageId = Number(root.dataset.footageVariant);
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!footageId || !form) return;
    root.dataset.bundled = 'true';
    document.addEventListener('submit', async (event) => {
      const target = event.target;
      if (!target || !target.matches || !target.matches('form[action*="/cart/add"]')) return;
      const data = new FormData(target);
      const id = Number(data.get('id'));
      if (!id || id === footageId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (target.dataset.acBundling) return;
      target.dataset.acBundling = 'true';
      const quantity = Math.max(1, Number(data.get('quantity')) || 1);
      const button = target.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      try {
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        if (document.querySelector('.hb-page') && window.acEnsureProjector) {
          await window.acEnsureProjector(id, footageId);
        } else {
          const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: quantity }, { id: footageId, quantity: 1 }] }) });
          if (!response.ok) throw new Error('add failed');
        }
        window.location.assign(base + 'cart');
      } catch (error) {
        delete target.dataset.acBundling;
        if (button) button.disabled = false;
        const box = target.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        if (box) { box.hidden = false; const text = box.querySelector('.product-form__error-message'); if (text) text.textContent = error.message || 'Could not update your cart. Please try again.'; }
      }
    }, true);
  };
  const start = () => { setup(document); bundle(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peepcreep-product"]) return;
  try {
    
function mountPeepCreep(scope=document){scope.querySelectorAll('[data-peepcreep]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const slides=root.querySelector('[data-slides]'),photos=[...slides.children],counter=root.querySelector('[data-count]'),select=root.querySelector('[data-variant]'),add=root.querySelector('[data-add]'),sticky=root.querySelector('[data-sticky]');
let index=0;const show=i=>{index=(i+photos.length)%photos.length;slides.scrollTo({left:photos[index].offsetLeft-slides.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
root.querySelector('[data-prev]').addEventListener('click',()=>show(index-1));root.querySelector('[data-next]').addEventListener('click',()=>show(index+1));
slides.addEventListener('scroll',()=>{index=Math.max(0,Math.min(photos.length-1,Math.round(slides.scrollLeft/slides.clientWidth)));counter.textContent=(index+1)+' / '+photos.length},{passive:true});counter.textContent='1 / '+photos.length;
root.querySelector('.pc-gallery').addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1))}});
const refresh=()=>{const option=select.selectedOptions[0],qty=root.querySelector('input[name=quantity]:checked').value,offers=root.querySelector('.pc-offers'),sale=Number(option.dataset.sale)>0;
root.querySelector('.pc-price').textContent=option.dataset.price;
root.querySelector('s[data-regular]').textContent=option.dataset.regular;root.querySelector('s[data-regular]').hidden=!sale;
root.querySelector('[data-sale]').textContent=offers.dataset.percentTemplate.replace('[percent]',option.dataset.percent);root.querySelector('[data-sale]').hidden=!sale;
root.querySelector('b[data-single]').textContent=option.dataset.price;root.querySelector('b[data-pair]').textContent=option.dataset.pair;
root.querySelector('[data-single-regular]').textContent=option.dataset.regular;root.querySelector('[data-single-regular]').hidden=!sale;
root.querySelector('s[data-pair-regular]').textContent=option.dataset.pairRegular;
root.querySelector('small[data-single-saving]').textContent=sale?offers.dataset.saveTemplate.replace('[amount]',option.dataset.singleSaveMoney):'';
root.querySelector('small[data-pair-saving]').textContent=offers.dataset.saveTemplate.replace('[amount]',option.dataset.pairSaveMoney);
root.querySelector('em[data-pair-percent]').textContent=offers.dataset.percentTemplate.replace('[percent]',option.dataset.pairPercent);
root.querySelector('[data-sticky-price]').textContent=qty==='2'?option.dataset.pair:option.dataset.price;add.disabled=option.dataset.available!=='true';{const buy=root.querySelector('[data-buy]');if(buy)buy.disabled=add.disabled}add.textContent=add.disabled?add.dataset.sold:add.dataset.label;root.querySelector('[data-sticky-add]').disabled=add.disabled;root.querySelector('[data-sticky-add]').textContent=add.textContent};
select.addEventListener('change',()=>{refresh();const found=photos.findIndex(p=>p.dataset.variantImage===select.value);if(found>=0)show(found);const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url)});
root.querySelectorAll('input[name=quantity]').forEach(el=>el.addEventListener('change',refresh));refresh();
root.querySelectorAll('[data-choose]').forEach(button=>button.addEventListener('click',()=>{select.value=button.dataset.choose;select.dispatchEvent(new Event('change',{bubbles:true}));root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'})}));
root.querySelector('[data-sticky-add]').addEventListener('click',()=>{if(!add.disabled)root.querySelector('form').requestSubmit(add)});
const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||add.getBoundingClientRect().top>0},{threshold:0});observer.observe(add);
const supplied=new URL(location.href).searchParams.get('variant');if(supplied){const found=photos.findIndex(p=>p.dataset.variantImage===supplied);if(found>=0)show(found)}
})}mountPeepCreep();document.addEventListener('shopify:section:load',e=>mountPeepCreep(e.target));

  } catch(e) { console.error(e); }
})();
})();
